export const capitaliseSentence = (sentence: string, delimiter = " ") => {
    if (!sentence) {
        return "";
    }
    const words = sentence.toLowerCase().split(delimiter);
    return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};
